<template>
  <div class="ev-page-container">
    <!-- edit daily log -->
    <modal
      name="edit-daily-log-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      width="800"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-daily-log
        title="događaji"
        :selectedDailyLog="selectedDailyLog"
        :employeeName="selectedNameValue"
        :showContextMenuForceDeparture="false"
        :showContextMenuDeactivate="false"
        :showManualLogAdd="false"
        :dontShowAllLogs="true"
      >
      </edit-daily-log>
    </modal>

    <!-- add stadion-tatjana-01 modal -->
    <modal
      name="add-stadion-tatjana-01-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <edit-stadion-tatjana-01
        :selectedItem="selectedItem"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisible="false"
        :statuses="statuses"
        :employees="employeesForEditList"
        :isEmployeesVisible="true"
        :departments="departmentData"
        :isStatusesVisible="true"
        :isDatesVisible="false"
        title="izmjena komentara"
        @saveAndCloseClicked="addItem"
        @saveAndProceedClicked="closeItem"
      />
    </modal>

    <!-- toggle late justified modal -->
    <modal
      name="toggle-late-justified-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
      @before-close="modalClosed"
    >
      <toggle-late-justified
        title="Vrsta kašnjenja"
        :startDate="startDate"
        :endDate="endDate"
        :selectedDailyLog="selectedDailyLog"
        :isSaveAndProceedButtonVisibl="false"
        @saveAndCloseClicked="changeLateType"
      />
    </modal>

    <!-- Page Header -->
    <div class="ev-page-header">
      <h1 class="ev-page-title">Pregled dnevne prisutnosti</h1>
      <p class="ev-page-subtitle">
        Detaljan pregled dnevne prisutnosti za sve sektore
      </p>
    </div>

    <!-- Filters Card -->
    <div class="ev-filters-card no-print">
      <div class="ev-filters-grid">
        <!-- Tab Buttons -->
        <div class="ev-filter-group">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">📅</span>
            Period
          </label>
          <div class="ev-tab-buttons">
            <button
              class="ev-tab-btn"
              :class="{ 'ev-tab-btn--active': tabSelector === 0 }"
              @click="tabClicked(0)"
            >
              Danas
            </button>
            <button
              class="ev-tab-btn"
              :class="{ 'ev-tab-btn--active': tabSelector === 1 }"
              @click="tabClicked(1)"
            >
              Juče
            </button>
            <button
              class="ev-tab-btn"
              :class="{ 'ev-tab-btn--active': tabSelector === 2 }"
              @click="tabClicked(2)"
            >
              Proizvoljan dan
            </button>
          </div>
        </div>

        <!-- Date Picker (when custom date selected) -->
        <div class="ev-filter-group" v-show="tabSelector === 2">
          <label class="ev-filter-label">
            <span class="ev-filter-icon">🗓️</span>
            Izaberi datum
          </label>
          <date-picker
            v-model="time3"
            @input="dateChosen"
            class="ev-date-picker"
          ></date-picker>
        </div>
      </div>
    </div>

    <!-- Inconsistences -->
    <inconsistences-view
      v-if="startDate"
      :date="startDate"
      :tomorrow="endDate"
      :logs="dailyLogs"
    />

    <!-- Filter (hidden) -->
    <BulmaAccordion
      v-show="false"
      class="no-print"
      dropdown
      :icon="'caret'"
      :caretAnimation="{
        duration: '.1s',
        timerFunc: 'ease-in-out',
      }"
      :slide="{
        duration: '.1s',
        timerFunc: 'ease',
      }"
    >
      <BulmaAccordionItem>
        <h4 slot="title">Filteri...</h4>
        <div slot="content">
          <div>
            <div class="columns">
              <div class="column is-narrow">
                <label class="label">Prikaži samo kašnjenje preko </label>
              </div>
              <div class="column is-narrow">
                <input class="input" v-model.number="filterLateValue" />
              </div>
              <div class="column is-narrow">
                <label class="label">minuta </label>
              </div>
              <div class="column is-narrow">
                <button class="button" @click="filterLateApplied">
                  Primijeni
                </button>
              </div>
            </div>
          </div>
        </div>
      </BulmaAccordionItem>
    </BulmaAccordion>

    <!-- Loading State -->
    <div class="ev-loading-state" v-if="isLoading">
      <div class="ev-loading-spinner"></div>
      <p>Učitavanje podataka...</p>
    </div>

    <!-- Departments Tables -->
    <div class="ev-departments-container" v-else>
      <div
        class="ev-department-section"
        v-for="department in departments"
        :key="department.id"
      >
        <daily-presence-table
          :department="department"
          :departmentData="departmentData"
          :inputDailyLogs="dailyLogs"
          :statuses="statuses"
          :startDate="startDate"
          :endDate="endDate"
          :filterLateValue="filterLateValue"
          @editCommentClicked="editCommentClicked"
          @editLateJustifiedClicked="editLateJustifiedClicked"
          @showEditDailyLogClicked="showEditDailyLogClicked"
        ></daily-presence-table>
      </div>
    </div>

    <!-- Empty State -->
    <div
      class="ev-empty-state"
      v-if="
        !isLoading && departments.length === 0 && tabSelector === 2 && !time3
      "
    >
      <div class="ev-empty-icon">📊</div>
      <h3>Izaberite datum</h3>
      <p>
        Odaberite datum iz kalendara da biste vidjeli dnevni pregled
        prisutnosti.
      </p>
    </div>
  </div>
</template>

<script>
// import UserService from "../../services/user.service";
// import ReportService from "../../services/report.service";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import EditDailyLog from "../parts/EditDailyLog.vue";

import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";

import DailyPresenceTable from "../parts/DailyPresenceTable.vue";
import EditStadionTatjana01 from "../parts/EditStadionTatjana01.vue";
import ToggleLateJustified from "../parts/ToggleLateJustified.vue";
import ReportService from "../../services/report.service";
import InconsistencesView from "../parts/InconsistencesView.vue";

import specialreportService from "../../services/specialreport.service";
import {
  getReport01TitlePropertyFromStatusId,
  getReport01recursivePropertyFromStatusId,
  getDepartmentFromEmployeeId,
} from "../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#ecfeff",
];

export default {
  name: "DailyPresence",
  components: {
    DatePicker,
    BulmaAccordion,
    InconsistencesView,
    BulmaAccordionItem,
    DailyPresenceTable,
    EditStadionTatjana01,
    ToggleLateJustified,
    EditDailyLog,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departmentData: null,
      departments: [],
      employees: [],
      dailyLogs: [],
      selectedDailyLog: null,
      statuses: [],
      selectedDepartment: null,
      selectedEmployee: null,
      selectedNameValue: null,
      startDate: new Date(),
      endDate: new Date(),
      employeeId: null,
      time3: null,
      isLoading: false,
      employeesForEditList: [],
      selectedItem: {
        boldText: "",
        note: "",
        employeeId: null,
        previewString: "",
      },
      filterLateValue: 0,

      params: {
        data: [
          [
            "Index",
            "Datum",
            "Ime i prezime",
            "Sektor",
            "Dolazak na posao",
            "Odlazak sa posla",
            "Izlasci",
            "Odmor/Doručak",
            "Radni sati u zgradi",
            "Radni sati van zgrade",
            "Radni sati",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 1, width: "7%" },
        ],
        sort: [0, 1, 2, 4, 5, 6, 7, 8, 9, 10],
        highlight: { column: [-1] },
        highlightedColor: colors[6],
      },
    };
  },
  mounted() {
    this.tabClicked(1);
  },
  activated() {},
  methods: {
    dateChosen(date) {
      this.startDate = date;

      let nextDay1 = new Date(date);
      nextDay1.setDate(date.getDate() + 1);
      let tomorrow = nextDay1;
      // console.log(this.tomorrow);
      this.startDate.setHours(0, 0, 0, 0);
      tomorrow.setHours(0, 0, 0, 0);

      this.endDate = tomorrow;

      this.resetUi();
      this.getData();
    },
    timeSpanChosen(span) {
      if (span[0] == null || span[1] == null) {
        return;
      }
      this.startDate = span[0];
      this.endDate = span[1];
      this.resetUi();
      this.getData();
    },
    addItem(item) {
      this.$modal.hide("add-stadion-tatjana-01-modal");
      console.log("xxItemxx");
      console.log(item);

      // let i = "Godišnji odmor";
      let statusId = item.statusId;
      let i = getReport01TitlePropertyFromStatusId(item.statusId);
      let employeeId = item.employeeId;
      this.employeeId = employeeId;
      let employeeName = this.$store.state.general.employees.find(
        (e) => e.id === employeeId
      ).name;
      let recursive = getReport01recursivePropertyFromStatusId(statusId);
      console.log("i");
      console.log(i);
      console.log(statusId);
      console.log(employeeId);
      console.log(employeeName);
      console.log(recursive);
      let data = {
        boldText: employeeName,
        note: item.note,
        userReportId: 2,
        isConfirmed: true,
        employeeId: item.employeeId,
        statusId: statusId,
        sRecursive: recursive,
      };
      console.log("gododmor");
      console.log(data);
      specialreportService
        .PostDailyReport01(data, this.startDate, i)
        .then((rsp) => {
          console.log(rsp);
          this.resetUi(true);
          this.getData();
          ReportService.GetNormalizedAccessDataByTimeRange(
            this.startDate,
            this.endDate,
            this.employeeId,
            null
          );
          // ReportService.EditDailyLogNoteByDateAndEmployeeId(
          //   this.startDate,
          //   item.employeeId,
          //   item.note
          // ).then((rsp) => {
          //   console.log(rsp.statusText);
          //   let myConnectedStatusId = item.statusId;
          //   if (myConnectedStatusId !== null) {
          //     ReportService.EditDailyLogStatusIdByDateAndEmployeeId(
          //       this.startDate,
          //       item.employeeId,
          //       myConnectedStatusId
          //     ).then((rsp) => {
          //       console.log(rsp.statusText);
          //     });
          //     this.resetUi(true);
          //     this.getData();
          //   }
          // });
        });
    },
    closeItem() {
      this.$modal.hide("add-stadion-tatjana-01-modal");
    },
    editCommentClicked(data) {
      this.employeesForEditList = [];
      console.log("22");
      console.log(data.emp);
      this.selectedItem.employeeId = data.emp.employeeId;
      console.log(this.selectedItem);
      this.employeesForEditList = [];
      this.employeesForEditList.push({
        id: data.emp.employeeId,
        name: data.emp.firstName + " " + data.emp.lastName,
        departmentName: getDepartmentFromEmployeeId(
          this.$store.state.general.departmentData,
          data.emp.employeeId
        ),
      });
      console.log("23");
      this.selectedDailyLog = data.dl;
      console.log(data.dl);
      this.$modal.show("add-stadion-tatjana-01-modal");
    },
    editLateJustifiedClicked(data) {
      // console.log("xxx3");
      // console.log(data);
      // this.selectedItem.employeeId = data.emp.employeeId;
      // this.employeesForEditList = [];
      // this.employeesForEditList.push({
      //   id: data.emp.employeeId,
      //   name: data.emp.firstName + " " + data.emp.lastName,
      //   departmentName: getDepartmentFromEmployeeId(
      //     this.$store.state.general.departmentData,
      //     data.emp.employeeId
      //   ),
      // });
      this.selectedDailyLog = data.dl;
      this.$modal.show("toggle-late-justified-modal");
    },
    showEditDailyLogClicked(data) {
      this.selectedDailyLog = data.dl;
      console.log(data);
      this.selectedEmployee = data.emp;
      this.selectedNameValue =
        this.selectedEmployee.firstName + " " + this.selectedEmployee.lastName;
      this.$modal.show("edit-daily-log-modal");
    },
    changeLateType(t) {
      console.log(t);
      this.$modal.hide("toggle-late-justified-modal");
      this.resetUi(true);
      this.getData();
    },

    modalClosed() {},
    getDepartments() {
      this.isLoading = true;
      ReportService.GetStatuses().then((response) => {
        this.statuses = response.data;
        ReportService.GetAllDepartmentsOfMyCompanyHistorically(
          this.startDate,
          this.endDate
        ).then((response) => {
          // reset ui
          // console.log(response.data);
          this.departmentData = response.data;
          this.arrangeSectors(response.data);
          this.arrangeEmployees(response.data);
          this.isLoading = false;
        });
      });
    },
    tabClicked(value) {
      this.tabSelector = value;
      if (value === 0) {
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        let today = new Date();
        yesterday.setHours(24, 0, 0, 0);
        today.setHours(24, 0, 0, 0);
        this.startDate = yesterday;
        this.endDate = today;
        this.resetUi();
        this.getData();
      } else if (value === 1) {
        let dayBeforeYesterday = new Date(
          new Date().setDate(new Date().getDate() - 2)
        );
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        this.startDate = dayBeforeYesterday;
        yesterday.setHours(24, 0, 0, 0);
        dayBeforeYesterday.setHours(24, 0, 0, 0);
        this.endDate = yesterday;
        this.resetUi();
        this.getData();
      } else if (value === 2) {
        this.startDate = null;
        this.endDate = null;
        this.resetUi();
      }
      this.resetUi();
      this.selectedEmployee = null;
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
    },
    resetUi(isFull = true) {
      this.params.data = [
        [
          "Index",
          "Datum",
          "Ime i prezime",
          "Sektor",
          "Dolazak na posao",
          "Odlazak sa posla",
          "Izlasci",
          "Odmor/Doručak",
          "Radni sati u zgradi",
          "Radni sati van zgrade",
          "Radni sati",
        ],
      ];
      this.dailyLogs = [];
      this.departments = [];
      if (isFull) {
        this.selectedDepartment = null;
        this.selectedEmployee = null;
        this.selectedItem = {
          boldText: "",
          note: "",
          employeeId: null,
          previewString: "",
        };
      }
    },
    getData() {
      this.isLoading = true;
      ReportService.GetDailyLogsByDate(this.startDate, this.endDate).then(
        (response) => {
          console.log("today");
          console.log(response.data);
          this.dailyLogs = response.data;

          this.getDepartments();
        }
      );
    },
    filterLateApplied() {
      this.resetUi();
      this.getData();
      console.log(this.filterLateValue);
    },
  },
};
</script>

<style scoped>
/* Tab Buttons */
.ev-tab-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ev-tab-btn {
  padding: 10px 20px;
  border: 2px solid var(--ev-border);
  border-radius: var(--ev-radius);
  background: var(--ev-bg);
  color: var(--ev-text-secondary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ev-tab-btn:hover {
  border-color: var(--ev-primary-start);
  color: var(--ev-primary-start);
}

.ev-tab-btn--active {
  background: var(--ev-primary-gradient);
  border-color: transparent;
  color: white;
}

.ev-tab-btn--active:hover {
  border-color: transparent;
  color: white;
}

/* Departments Container */
.ev-departments-container {
  display: flex;
  flex-direction: column;
  gap: var(--ev-spacing-lg);
}

.ev-department-section {
  background: white;
  border-radius: var(--ev-radius-lg);
  overflow: hidden;
  box-shadow: var(--ev-shadow);
}

/* Loading State */
.ev-loading-state {
  background: white;
  border-radius: var(--ev-radius-lg);
  padding: 64px 24px;
  text-align: center;
  box-shadow: var(--ev-shadow);
}

.ev-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--ev-border);
  border-top-color: var(--ev-primary-start);
  border-radius: 50%;
  margin: 0 auto 16px;
  animation: ev-spin 1s linear infinite;
}

@keyframes ev-spin {
  to {
    transform: rotate(360deg);
  }
}

.ev-loading-state p {
  font-size: 14px;
  color: var(--ev-text-muted);
  margin: 0;
}

@media print {
  .ev-department-section,
  .ev-departments-container {
    overflow: visible !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .ev-department-section {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
</style>